import {useEffect} from 'react';
import {useMutation} from '@tanstack/react-query';
import {dataExtractor} from './useFetch';
import {useDispatch} from 'react-redux';
import {useState} from 'react';
import {useMemo} from 'react';

const useSubmit = ({
  service,
  dataOnly = false,
  id,
  onSuccess,
  successToast = true,
  pagination = false,
  props = {},
  // condition = true,
  // conditionalRefetch,
  fb,
}) => {
  const dispatch = useDispatch();
//   const [page, setPage] = useState(0);
//   const [limit, setLimit] = useState(10);

//   useEffect(() => {
//     if (!pagination) return;
//     setPage(0);
//     setLimit(10);
//   }, [pagination]);

//   const nextPage = () => setPage(page + 1);
//   const prevPage = () => setPage(page - 1);

//   data = {
//     ...(pagination ? {page: page || 1, pageSize: limit || '10'} : {}),
//     ...data,
//   };

  let {mutate, isLoading, isSuccess, error, data} = useMutation(input =>
    service({
      id,
      ...input,
      ...props,
    }),
  );

  data = dataExtractor(data);
  useEffect(() => {
    if (isSuccess && onSuccess) onSuccess(data);

    
    // if (error) {
    //   dispatch(setAlertMsg({status: 'error', message: error?.message}));
    // }
  }, [error, isSuccess]);

  if (dataOnly) return data;

  return {
    submit: mutate,
    data,
    isLoading,
    isSuccess,
    error,
    // nextPage,
    // prevPage,
    // page,
    // setPage,
  };
};

export default useSubmit;